import gql from 'graphql-tag'
import { ClipsContainer_video } from './video/components/ClipsContainer.fragments'
import { ReelFeedback_video } from './video/components/ReelFeedback.fragments'

const VIDEO_QUERY = gql`
  query VideoQuery($videoId: ID!) {
    node(id: $videoId) {
      __typename
      ... on Video {
        id
        url
        title
        highlightTrends {
          polarity
          startTime
          endTime
        }
        ...ClipsContainer_video
        ...ReelFeedback_video
        transcript {
          rawTranscript {
            results {
              items {
                startTime
                endTime
                type
                alternatives {
                  content
                }
              }
            }
          }
        }
      }
    }
  }
  ${ReelFeedback_video}
  ${ClipsContainer_video}
`

export default VIDEO_QUERY



// WEBPACK FOOTER //
// ./src/routes/video.query.js